"use strict";

exports.__esModule = true;
exports.TYPE_OPTIONS = exports.SIZE_OPTIONS = void 0;
let TYPE_OPTIONS = exports.TYPE_OPTIONS = /*#__PURE__*/function (TYPE_OPTIONS) {
  TYPE_OPTIONS["NEUTRAL"] = "neutral";
  TYPE_OPTIONS["INFO"] = "info";
  TYPE_OPTIONS["SUCCESS"] = "success";
  TYPE_OPTIONS["WARNING"] = "warning";
  TYPE_OPTIONS["CRITICAL"] = "critical";
  return TYPE_OPTIONS;
}({});
let SIZE_OPTIONS = exports.SIZE_OPTIONS = /*#__PURE__*/function (SIZE_OPTIONS) {
  SIZE_OPTIONS["SMALL"] = "small";
  SIZE_OPTIONS["NORMAL"] = "normal";
  return SIZE_OPTIONS;
}({});